import React from 'react';

import { Grid } from '@lp/ds-next';
import { Flex } from 'antd';

import BoxContractTable from './components/BoxContractTable';
import CreateBoxContract from './components/CreateBoxContract';
import useContractsStore from './hooks/useContractsStore';
import ServerSearch from '@/components/ServerSearch';
import { storeSelector } from '@/helpers/paginatedStoreHelpers';

const BoxContractsListView = () => {
  const { dispatch, searchTerms } = useContractsStore(storeSelector);

  return (
    <Grid container justifyContent="center" spacing={3}>
      <Grid container item mobile={11}>
        <Flex gap={32} align="center" style={{ width: '100%' }}>
          <ServerSearch
            fields={[
              { key: 'search', placeholder: 'Last name, first name or email' },
            ]}
            dispatch={dispatch}
            storeSearchTerms={searchTerms}
          />
          <CreateBoxContract />
        </Flex>
      </Grid>
      <Grid item mobile={11}>
        <BoxContractTable hasFilters={{ paymentDate: true }} />
      </Grid>
    </Grid>
  );
};

export default BoxContractsListView;
